import { WorkReportDocType } from '../form/work-report-doc-type.enum';
import { JgPhysicalInspUnitFx } from './jg-physical-insp-unit-fx.model';
import { JgPhysicalInspUnitItemInfo } from './jg-physical-insp-unit-item-info.model';
export class JgPhysicalInspUnitItemBatchRequest {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  dwCode?: string;
  jgFbName?: string;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  docType?: WorkReportDocType;
  docId?: string;
  docName?: string;
  docSnNo?: string;
  docSubmitDate?: number;
  docSubmitDateDate?: Date;
  docFinishDate?: number;
  docFinishDateDate?: Date;
  itemInfos?: Array<JgPhysicalInspUnitItemInfo>;

  constructor(
    init?: JgPhysicalInspUnitFx,
    docType?: WorkReportDocType.DEFAULT | WorkReportDocType.PDF_SIGNED,
    docId?: string,
    docName?: string,
    docSnNo?: string,
    docSubmitDate?: number,
    docFinishDate?: number,
  ) {
    if (init) {
      this.projectId = init.projectId;
      this.jgSectionId = init.jgSectionId;
      this.sectionId = init.sectionId;
      this.dwCode = init.dwCode;
      this.jgFbName = init.jgFbName;
      this.jgFxName = init.jgFxName;
      this.jgFxProjectTypeCode = init.jgFxProjectTypeCode;
      this.docType = docType;
      this.docId = docId;
      this.docName = docName;
      this.docSnNo = docSnNo;
      this.docSubmitDate = docSubmitDate;
      this.docFinishDate = docFinishDate;
    }
  }
}
